// import '../node_modules/core-js/index.js'
import React, { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import './index.css'
import 'isomorphic-fetch'
import { getBaseURL } from '../GlobalComponents/URLs.jsx'

export default (props) => {
    const [recoveredRecords, setRecoveredRecords] = useState(false)
    useEffect(() => {
        let fetchUrl = getBaseURL() + 'webapi/form/autosaveForm' //"https://markpc.awc-inc.com:444/webapi/form/autosaveForm";//
        fetch(fetchUrl, {
            method: 'GET',
            credentials: 'include',
        })
            .then((resp) => {
                if (resp.ok) return resp.json()
                else throw new Error('Fetch failed ' + resp.statusText)
            })
            .then((json) => {
                setRecoveredRecords(
                    json.map((ele, i) => {
                        let record = JSON.parse(ele.rawJson)
                        let keyStr = record.autosaveMetadata.keyStr
                        return {
                            record: record,
                            keyStr: keyStr,
                            autosaveId: ele.autosaveId,
                            recordId: ele.recordId,
                            form: ele.form,
                            lastUpdated: ele.lastUpdated,
                        }
                    })
                )
            })
            .catch((e) => {
                console.warn(e)
            })
    }, [])

    const handleRecordSelect = (i) => {
        return () => {
            window.location = './recoverRecord/' + recoveredRecords[i].autosaveId.toString()
        }
    }

    const deleteSave = (autosaveId) => {
        let removeAutoUrl = getBaseURL() + 'webapi/form/removeAutosave/' + autosaveId
        fetch(removeAutoUrl, {
            credentials: 'include',
        })
    }
    return (
        <div className="formContainer">
            <div className="row">
                <div className="col-3"></div>
                <div>
                    <h3 style={{ marginTop: 20, marginBottom: 10, marginLeft: 20 }}>
                        Select Record to Recover
                    </h3>
                    {recoveredRecords === false && <p>Loading saves</p>}
                    {recoveredRecords !== false &&
                        recoveredRecords.map((ele, i) => {
                            let [tagNumber, serialNumber, tagNumberOrig, serialNumberOrig] = [
                                ...ele.keyStr.split('|'),
                            ]
                            return (
                                <Card style={{ width: '25rem' }}>
                                    <Card.Body>
                                        <Card.Title>Form: {ele.form}</Card.Title>
                                        {/* <Card.Title>{ele.recordId === "-1" ? `Autosave ${ele.autosaveId}` : `Record ${ele.recordId}`}</Card.Title> */}
                                        {ele.recordId === '-1' ? (
                                            <Card.Subtitle>{'No linked record'}</Card.Subtitle>
                                        ) : (
                                            <Card.Subtitle>{`RecordID ${ele.recordId}`}</Card.Subtitle>
                                        )}
                                        <Card.Text>
                                            <p>
                                                Last Updated: {ele.lastUpdated}
                                                <br />
                                                tag: {tagNumber || tagNumberOrig}
                                                <br />
                                                serial: {serialNumber || serialNumberOrig}
                                            </p>
                                        </Card.Text>

                                        <Button
                                            variant="danger"
                                            onClick={() => {
                                                deleteSave(ele.autosaveId)
                                                setRecoveredRecords((recoveredRecords) => {
                                                    recoveredRecords.splice(i, 1)
                                                    return [...recoveredRecords]
                                                })
                                            }}
                                        >
                                            Delete
                                        </Button>
                                        <div style={{ display: 'inline-block', width: '10rem' }} />
                                        <Button variant="primary" onClick={handleRecordSelect(i)}>
                                            Recover
                                        </Button>
                                    </Card.Body>
                                </Card>
                            )
                        })}
                    {recoveredRecords !== false && recoveredRecords.length === 0 && <p>No saves</p>}
                </div>
            </div>
        </div>
    )
}
